import { VFC } from 'react';

import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { LinkifyExternal } from 'dashboard/components/LinkifyExternal';
import { ReportBusinessClassification } from 'dashboard/models/report/business-classification';

interface BusinessClassificationProps {
  report: ReportBusinessClassification;
  isRedacted: boolean;
}

const BusinessClassification: VFC<BusinessClassificationProps> = ({
  report,
  isRedacted,
}: BusinessClassificationProps) => {
  const {
    'business-name': businessName,
    website: website,
    'address-street-1': addressStreet1,
    'address-street-2': addressStreet2,
    'address-city': addressCity,
    'address-subdivision': addressSubdivision,
    'address-postal-code': addressPostalCode,
    'address-country-code': addressCountryCode,
  } = report.attributes?.query ?? {};
  return (
    <AttributeGrid colCount={4}>
      <AttributeItem
        title='Business Name'
        value={businessName}
        placeholder='N/A'
        isRedacted={isRedacted}
      />
      <AttributeItem
        title='Website'
        value={<LinkifyExternal>{website}</LinkifyExternal>}
        placeholder='N/A'
        isRedacted={isRedacted}
      />
      <AttributeItem
        title='Address Street 1'
        value={addressStreet1}
        placeholder='N/A'
        isRedacted={isRedacted}
      />
      <AttributeItem
        title='Address Street 2'
        value={addressStreet2}
        placeholder='N/A'
        isRedacted={isRedacted}
      />
      <AttributeItem
        title='Address City'
        value={addressCity}
        placeholder='N/A'
        isRedacted={isRedacted}
      />
      <AttributeItem
        title='Address Subdivision'
        value={addressSubdivision}
        placeholder='N/A'
        isRedacted={isRedacted}
      />
      <AttributeItem
        title='Address Postal Code'
        value={addressPostalCode}
        placeholder='N/A'
        isRedacted={isRedacted}
      />
      <AttributeItem
        title='Address Country Code'
        value={addressCountryCode}
        placeholder='N/A'
        isRedacted={isRedacted}
      />
    </AttributeGrid>
  );
};

export default BusinessClassification;
